export default __webpack_public_path__ + "static/media/74.93710d34.jpg";